function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import KZUIComponent from '../base';
import Popup from '../Popup';
import { valueType, optionListType } from '../base/types';
import EventBlackHole from '../EventBlackHole';
import Option from './Option';
import './style.less';

var OptionContainer = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(OptionContainer, _KZUIComponent);

  var _super = _createSuper(OptionContainer);

  function OptionContainer(props) {
    var _this;

    _classCallCheck(this, OptionContainer);

    _this = _super.call(this, props);

    _this.autoBind('handleWheel');

    return _this;
  }

  _createClass(OptionContainer, [{
    key: "handleWheel",
    value: function handleWheel(e) {
      if (e.deltaY > 0) {
        if (this.opts.scrollHeight - this.opts.clientHeight - this.opts.scrollTop <= 0) {
          e.stopPropagation();
          e.preventDefault();
        }
      } else if (this.opts.scrollTop <= 0) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var clsPrefix = 'kui-select';
      var _this$props = this.props,
          expand = _this$props.expand,
          style = _this$props.style,
          contentStyle = _this$props.contentStyle,
          value = _this$props.value,
          handleSelect = _this$props.handleSelect,
          options = _this$props.options;
      return /*#__PURE__*/React.createElement(EventBlackHole, {
        captureEvents: ['click']
      }, /*#__PURE__*/React.createElement(Popup, {
        hide: !expand,
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--options"),
        ref: this.storeRef('opts'),
        style: contentStyle,
        onWheel: this.handleWheel
      }, options.map(function (option, index) {
        return /*#__PURE__*/React.createElement(Option, {
          key: "option-".concat(index),
          value: option.value,
          selected: value === option.value,
          onClick: handleSelect
        }, option.text);
      }), this.props.hasMore ? /*#__PURE__*/React.createElement(Option, {
        disable: true,
        value: "",
        onClick: this.props.handleLoadMore
      }, "\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A") : null)));
    }
  }]);

  return OptionContainer;
}(KZUIComponent);

OptionContainer.defaultProps = {
  value: 0,
  expand: false,
  options: [],
  hasMore: false,
  handleSelect: {},
  handleLoadMore: {},
  style: {},
  contentStyle: {}
};
OptionContainer.propTypes = {
  value: valueType,
  expand: PropTypes.bool,
  options: optionListType,
  hasMore: PropTypes.bool,
  handleSelect: PropTypes.func,
  handleLoadMore: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.any),
  contentStyle: PropTypes.objectOf(PropTypes.any)
};
export default OptionContainer;